export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const MIN_INDEX = 0;
export const CURRENT_LIMITS = [DAY, WEEK, MONTH];
